import startCase from 'lodash/startCase';
import { ProjectReport } from '../TypeScript/interfaces';

export const formatModelName = (fileStr: string): string => {
  const regex =
    /_with_glare_\[(\d+)\]_clusters_(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})\.pkl/;

  const match = fileStr.match(regex);
  if (match) {
    const [, clusterCount, year, month, day, hour, minute, second] = match;
    const modelNameDict: Record<string, string> = {
      munsel: 'Munsell Standard', // needs to be the first one, `munselinvestigation_GMM...` need to be displayed as "25 Colors - Munsell Standard - <date>""
      GMM: 'Gaussian',
      'K-Means': 'KMeans',
    };
    let modelUsed: string | undefined = Object.keys(modelNameDict).find((key) =>
      fileStr.includes(key),
    );
    let modelName = modelUsed ? modelNameDict[modelUsed] : '';
    return `${clusterCount} Clusters - ${modelName} - ${year}-${month}-${day}-${hour}-${minute}-${second}`;
  } else {
    return '';
  }
};

export const formatModelOption = (
  fileStr: string,
  stepSize: string,
): string | undefined => {
  const regex =
    /_with_glare_\[(\d+)\]_clusters_(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})\.pkl/;

  const match = fileStr.match(regex);
  if (match) {
    const [, clusterCount, year, month, day, hour, minute, second] = match;
    const modelNameDict: Record<string, string> = {
      GMM: 'Gaussian',
      'K-Means': 'KMeans',
    };
    let modelUsed: string | undefined = Object.keys(modelNameDict).find((key) =>
      fileStr.includes(key),
    );
    let modelName = modelUsed ? modelNameDict[modelUsed] : '';
    return `Dominant Colour - ${clusterCount} Clusters - ${modelName} - Step Size: ${stepSize}`;
  }
};

export const formatTextureModelOption = (modelOption: ProjectReport) => {
  return `Texture - ${startCase(modelOption.genericModelName)} - Step Size: ${
    modelOption.stepSize
  }`;
};

/**
 * Export the date in the format of "MM/DD/YY, HH:MM:SS AM/PM" from an ISO date string.
 * If the input is invalid, return a '-' string.
 * @param {string|null|undefined} isoDate - The ISO date string to be formatted
 * @returns {string} The formatted date string or a '-' string if the input is invalid
 */
export const formatDateShort = (isoDate: string | null | undefined): string => {
  if (!isoDate) return '-';
  return new Date(isoDate).toLocaleString([], {
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};
